module.exports = __webpack_public_path__ + "static/media/branding_01_A.8bb272f1.png";